var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.company)?_c('div',{staticClass:"jobsNew"},[_c('h1',[_vm._v("Criar Nova Oferta")]),_c('JobOfferForm')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }